import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SurveyResultsFilterNames } from 'models';
import {
	IFilterChangePayload,
	MAP_ZOOM_TYPE_INDEXES,
} from 'modules/admin-panel/pages/results/models';
import {
	getFromSessionStorage,
	SessionStorageKeyTypes,
} from 'utils/clientStorage';
import {
	calculatedRoundsSelector,
	statisticGroupingTypeSelector,
} from 'modules/admin-panel/pages/results/selectors/dashboard.selectors';
import { setActiveLocation } from 'modules/admin-panel/pages/results/results.actions';
import { useSurveyResultsFilter } from '../useSurveyResultsFilter';
import { setZoomTypeIndex } from '../../modules/admin-panel/pages/results/map.actions';

export const useSetActiveCity = () => {
	const dispatch = useDispatch();
	const {
		onChangeSurveyResultsFilter,
		surveyFilter,
	} = useSurveyResultsFilter();
	const surveyId = getFromSessionStorage(
		SessionStorageKeyTypes.dashboardSurveyId,
	);
	const rounds = useSelector(calculatedRoundsSelector);
	const groupingType = useSelector(statisticGroupingTypeSelector);

	const boundSetActiveLocation = useCallback(
		(p: IFilterChangePayload) => dispatch(setActiveLocation(p)),
		[dispatch],
	);

	const boundSetMapWorldZoom = useCallback(
		() => dispatch(setZoomTypeIndex(MAP_ZOOM_TYPE_INDEXES.cityZoom)),
		[dispatch],
	);

	return useCallback(
		(curCity?: string, curCountry?: string) => {
			boundSetActiveLocation({
				rounds,
				surveyId,
				...surveyFilter,
				region: undefined,
				country: curCountry,
				city: curCity,
				office: undefined,
				groupingType,
			});
			onChangeSurveyResultsFilter({
				[SurveyResultsFilterNames.region]: undefined,
				[SurveyResultsFilterNames.country]: curCountry,
				[SurveyResultsFilterNames.city]: curCity,
				[SurveyResultsFilterNames.office]: undefined,
			});
			boundSetMapWorldZoom();
		},
		[
			boundSetActiveLocation,
			boundSetMapWorldZoom,
			groupingType,
			onChangeSurveyResultsFilter,
			rounds,
			surveyId,
			surveyFilter,
		],
	);
};
